<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-center">
            <img
                src="../../assets/img/icon/allset.svg"
                style="width: 100%"
              />
        </div>
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="text-center">
              <h3 class="title mt-4" style="color: #000A2C">
                All set! Now sit back and<br />
                let us find your Tutor</h3>
            </div>
            <CCard class="custom-reward mb-5 ml-3 mr-3">
              <CRow>
                <div style="width: 100%" class="float-right">
                  <img
                    src="../../assets/img/icon/successimg.svg"
                  />
                </div>
                <div style="width: 70%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header ml-4 mt-4 mb-4"
                  >
                    Redeem Rewards <br />
                    <label class="sub-title-card">
                      Claim Reward Points <br />
                      and enjoy more discount <br />
                      with Pickiddo</label
                    >
                    <CButton color="info" class="custom-header-btn mt-3">
                      Redeem Now</CButton
                    >
                  </h3>
                </div>
              </CRow>
            </CCard>
          </div>
        </div>
        
      </div>
    </CContainer>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  methods: {
    // GoToExam(){
    //   this.$router.push(
    //     "/RegisterStudentExam"
    //   );
    // }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add{
font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 150%;

color: #007CEF;
}
</style>